export default "__VITE_ASSET__B_7rY4sA__"